import { PlantListSearchCriteria } from '../models';

export class PlantListLoad {
  public static readonly type = '[PlantList] Load';
  constructor(public payload: PlantListSearchCriteria) {}
}

export class PlantListInitialState {
  public static readonly type = '[PlantList] Set Initial State';
}
